import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="message-read"
export default class extends Controller {
  static values = {
    hasRead: { type: Boolean, default: false }
  }

  read({ params: { id } }) {
    console.log(id)
    if (this.hasReadValue) {
      return
    }

    const headers = new Headers()
    headers.append('Content-Type', 'application/json')
    const csrf = document.querySelector('[name="csrf-token"]')
    if (csrf) {
      headers.append('X-CSRF-Token', document.querySelector('[name="csrf-token"]').content)
    }

    fetch(`/messages/${id}/read`, {
      method: 'PUT',
      headers: headers,
      body: JSON.stringify({ message_id: id })
    }).then(_ => { this.hasReadValue = true })
  }
}
